import type { TooltipRenderProps } from 'react-joyride'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'

export default function PageTourTooltip({
  continuous,
  index,
  step,
  size,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}: TooltipRenderProps) {
  return (
    <Paper
      {...tooltipProps}
      elevation={8}
      sx={{
        maxWidth: 380,
        p: 2.5,
        borderRadius: 3,
        position: 'relative',
      }}
    >
      <IconButton
        {...closeProps}
        size="small"
        sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      {step.title && (
        <Typography
          variant="h6"
          sx={{ color: 'primary.main', pr: 3, mb: 0.5, fontSize: '1.05rem' }}
        >
          {step.title as string}
        </Typography>
      )}

      <Typography
        variant="body2"
        sx={{ color: 'text.secondary', mb: 2, lineHeight: 1.6 }}
      >
        {step.content as string}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
          {index + 1} of {size}
        </Typography>

        <Box sx={{ display: 'flex', gap: 1 }}>
          {index === 0 && size > 1 && (
            <Button
              {...skipProps}
              size="small"
              sx={{ textTransform: 'none', color: 'text.secondary' }}
            >
              Skip
            </Button>
          )}
          {index > 0 && (
            <Button
              {...backProps}
              size="small"
              sx={{ textTransform: 'none', color: 'text.secondary' }}
            >
              Back
            </Button>
          )}
          {continuous && !isLastStep && (
            <Button
              {...primaryProps}
              size="small"
              variant="contained"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                px: 2.5,
              }}
            >
              Next
            </Button>
          )}
          {isLastStep && (
            <Button
              {...primaryProps}
              size="small"
              variant="contained"
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 2,
                px: 2.5,
              }}
            >
              Done
            </Button>
          )}
        </Box>
      </Box>
    </Paper>
  )
}
